// v3.15-727 — Timezone-aware formatting forced to America/New_York (handles DST automatically).
// Input is a Date, ISO string, or timestamp. Output is always rendered in America/New_York.
// DB stays UTC — conversion happens at display time only.

const ET_TZ = "America/New_York";

function toDate(value) {
  if (value instanceof Date) return value;
  if (value === null || value === undefined || value === "") return null;
  const d = new Date(value);
  return isNaN(d.getTime()) ? null : d;
}

// Map common date-fns patterns to Intl.DateTimeFormat options.
function optsForPattern(pattern) {
  switch (pattern) {
    case "MMM d, h:mm a":
      return { month: "short", day: "numeric", hour: "numeric", minute: "2-digit", hour12: true, timeZone: ET_TZ };
    case "MMM d, yyyy h:mm a":
      return { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit", hour12: true, timeZone: ET_TZ };
    case "MMM d, yyyy":
      return { month: "short", day: "numeric", year: "numeric", timeZone: ET_TZ };
    case "MMM d, yy":
      return { month: "short", day: "numeric", year: "2-digit", timeZone: ET_TZ };
    case "MMM d":
      return { month: "short", day: "numeric", timeZone: ET_TZ };
    case "h:mm a":
      return { hour: "numeric", minute: "2-digit", hour12: true, timeZone: ET_TZ };
    case "M/d/yyyy":
    case "MM/dd/yyyy":
      return { month: "numeric", day: "numeric", year: "numeric", timeZone: ET_TZ };
    case "M/d/yy":
      return { month: "numeric", day: "numeric", year: "2-digit", timeZone: ET_TZ };
    case "PPpp":
      return { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit", second: "2-digit", hour12: true, timeZone: ET_TZ };
    default:
      // Fallback to full datetime
      return { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit", hour12: true, timeZone: ET_TZ };
  }
}

// Primary helper — matches the signature of date-fns `format(date, pattern)` but forces ET.
export function formatET(value, pattern = "MMM d, yyyy h:mm a") {
  const d = toDate(value);
  if (!d) return "";
  return new Intl.DateTimeFormat("en-US", optsForPattern(pattern)).format(d);
}

// Full localized string in ET, e.g. "4/17/2026, 1:50:34 PM"
export function formatETLocale(value) {
  const d = toDate(value);
  if (!d) return "";
  return d.toLocaleString("en-US", { timeZone: ET_TZ });
}

// Date-only in ET
export function formatETDate(value) {
  const d = toDate(value);
  if (!d) return "";
  return d.toLocaleDateString("en-US", { timeZone: ET_TZ });
}

// Time-only in ET
export function formatETTime(value) {
  const d = toDate(value);
  if (!d) return "";
  return d.toLocaleTimeString("en-US", { timeZone: ET_TZ });
}
